import React from "react";
import { createRoot } from "react-dom/client";
import Swal from 'sweetalert2';
import CookieConsentComponent from "../components/CookieConsentComponent";

window.Swal = Swal;

const roots = {};

const renderComponent = (Component, rootId, props = {}) => {
  const rootElement = document.getElementById(rootId);
  if (rootElement) {
    if (!roots[rootId]) {
      roots[rootId] = createRoot(rootElement);
    }
    roots[rootId].render(<Component {...props} />);
  }
};

renderComponent(CookieConsentComponent, "CookieConsentComponent");